import { Record, Map } from 'immutable';

export default class KeyframeRecord extends Record({
  key: '',
  t: 0,
  actions: new Map(),
  style: Map(),
  selected: false,
}) {
  setTimeQuantized(time) {
    const t = (typeof time === 'undefined') ? 0 : time;
    return this.set('t', parseFloat(t.toFixed(2)));
  }
}



// WEBPACK FOOTER //
// ./app/javascript/packs/App/Builder/records/KeyframeRecord.js